<template>
    <div class="page-company page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">店铺管理</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>客户管理</el-breadcrumb-item>
                            <el-breadcrumb-item>店铺管理</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleCompany('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="店铺名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="店铺名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="referrer" label="推荐人：">
                            <el-input v-model="form_search.referrer" size="small" placeholder="推荐人" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="status" label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
                            <el-table-column prop="name" align="center" label="店铺名称" min-width="180">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.name"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="consignee" align="center" label="联系人" min-width="120">
                            </el-table-column>
                            <el-table-column prop="mobile" align="center" label="联系电话" min-width="120">
                            </el-table-column>
                            <el-table-column prop="number" align="center" label="店铺编码" min-width="140">
                            </el-table-column>
                            <el-table-column prop="qrcode_url" align="center" label="店铺二维码" min-width="160">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="baseUrl + scope.row.qrcode_url+'?t='+timestamp" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.qrcode_url+'?t='+timestamp;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="addr" align="center" label="店铺地址" min-width="180">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.addr"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="max_user_count" align="center" label="店铺人数" min-width="120">
                            </el-table-column>
                            <el-table-column prop="low_consumption" align="center" label="最低消费/元" min-width="120">
                            </el-table-column>
                            <el-table-column prop="settlement_date" align="center" label="收账时间" min-width="160">
                            </el-table-column>
                            <el-table-column prop="referrer" align="center" label="推荐人" min-width="160">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" align="center" label="备注" width="180">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.remark"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="200" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleCompany('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-o" type="primary" size="mini" @click="$util.goTo('/user/list',{query:{desk_number:scope.row.number}})">人员</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteCompany(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export company-dialog" :title="dlg_company.title" :visible.sync="dlg_company.visible" width="534px" @closed="closeCompany" :close-on-click-modal="false">
            <el-form ref="formCompany" :model="dlg_company.form" label-width="110px" :rules="dlg_company.rules" @submit.native.prevent>
                <el-form-item prop="name" style="margin-top: 15px;" label="店铺名称：" :error="dlg_company.error.name">
                    <el-input size="small" v-model="dlg_company.form.name" placeholder='请输入店铺名称' clearable></el-input>
                </el-form-item>
                <el-form-item prop="consignee" label="联系人：">
                    <el-input size="small" v-model="dlg_company.form.consignee" placeholder='请输入店铺联系人' clearable></el-input>
                </el-form-item>
                <el-form-item prop="mobile" label="联系方式：">
                    <el-input size="small" type='number' v-model="dlg_company.form.mobile" placeholder='请输入店铺联系方式' clearable></el-input>
                </el-form-item>
                <el-form-item prop="addr" label="店铺地址：">
                    <el-input size="small" v-model="dlg_company.form.addr" placeholder='请输入店铺地址' clearable></el-input>
                </el-form-item>
                <el-form-item prop="max_user_count" label="店铺人数：">
                    <el-input size="small" v-model="dlg_company.form.max_user_count" placeholder='请输入店铺人数' clearable></el-input>
                </el-form-item>
                <el-form-item prop="low_consumption" label="最低消费/元：">
                    <el-input size="small" type='number' v-model="dlg_company.form.low_consumption" placeholder='请输入最低消费' clearable></el-input>
                </el-form-item>
                <el-form-item prop="settlement_date" label="收账时间：">
                    <el-input size="small" v-model="dlg_company.form.settlement_date" placeholder='请输入收账时间' clearable></el-input>
                </el-form-item>
                <el-form-item prop="referrer" label="推荐人：">
                    <el-input size="small" v-model="dlg_company.form.referrer" placeholder='请输入推荐人' clearable></el-input>
                </el-form-item>
                <el-form-item prop="remark" label="备注：">
                    <el-input v-model="dlg_company.form.remark" type="textarea" :rows="3" size="small" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item prop="status" label="状态：">
                    <el-radio-group v-model="dlg_company.form.status">
                        <el-radio v-for="(item, index) in dlg_company.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_company.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitCompany()" :loading="dlg_company.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                drawer: false,
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                baseUrl:this.$client.IMG_URL,
                timestamp:new Date().getTime(),
                //搜索
                form_search:{
                    //id: "",
                    name:"",
                    referrer:'',
                    status: -1,
                    type:1
                },
                init_data: {
                    status_list: [],
                },
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_company:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    form:{
                        type:1,
                        name:'',
                        consignee:'',
                        mobile:'',
                        number:'',
                        addr:'',
                        remark:'',
                        max_user_count:'',
                        low_consumption:'',
                        settlement_date:'',
                        referrer:'',
                        status:1
                    },
                    error:{
                        name:''
                    },
                    reset_form: {},
                    init_data:{
                        status_list: []
                    },
                    rules:{
                        name:{required: true, message: '请输入店铺名称', trigger: ['change','blur']},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']},
                    },
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '店铺管理';
            this.dlg_company.reset_form = Object.assign({}, this.dlg_company.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/desk/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_company.init_data.status_list = res.status_name_list;
                    _this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的店铺");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/desk/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },

            handleCompany(type,data){
                this.dlg_company.visible = true;
                if(type == 'add'){
                    this.dlg_company.title = '添加店铺';
                    this.dlg_company.api = '/adminapi/desk/save';
                }else{
                    this.dlg_company.id= data.id;
                    this.dlg_company.title = '编辑店铺';
                    if(data){
                        for(var key in this.dlg_company.form){
                            this.dlg_company.form[key] = data[key];
                        }
                    }
                    this.dlg_company.api = '/adminapi/desk/save?id=' + data.id;
                }
            },
            deleteCompany(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/desk/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitCompany(){
                var _this = this;
                _this.$refs['formCompany'].validate((valid) => {
                    if (valid) {
                        this.dlg_company.btn_loading = true;
                        this.$client.post(this.dlg_company.api, this.dlg_company.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_company.btn_loading = false;
                            _this.dlg_company.visible = false;
                        }, function(message){
                            _this.dlg_company.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_company.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeCompany(){
                for(var key in this.dlg_company.form){
                    this.dlg_company.form[key] = this.dlg_company.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formCompany.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .page-company .el-upload--picture-card{
        line-height: 80px;
    }
    .page-company .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
</style>
<style scoped>


</style>